module.exports = __webpack_public_path__ + "54d8a285236ab7a07926fd9521f2cf22.pdf";